// extracted by mini-css-extract-plugin
export var contentBody = "_4o-9";
export var headerImage = "_4o-2";
export var imageButton = "_4o-7";
export var imageButtonIcon = "_4o-8";
export var imageHeader = "_4o-4";
export var imageHeaderText = "_4o-5";
export var imageOverlay = "_4o-3";
export var imageTitle = "_4o-6";
export var imageWrapper = "_4o-1";
export var taskList = "_4o-a";
export var widget = "_4o-0";